
import { defineComponent } from "vue";
import { mapActions, mapGetters } from "vuex";
import { EventType, trackEvent } from '@/helpers/AmplitudeHelper';
import { isProEnabled } from "@/helpers/FeatureFlagHelper";

export default defineComponent({
  name: "PopupNotification",
  computed: {
    ...mapGetters([
      "showNotification",
      "notificationMessage",
      "notificationIsClosing",
    ]),
  },
  methods: {
    ...mapActions(["closeNotification"]),
    handleUrlClick(event: MouseEvent) {
      const reportLimitKeypath = isProEnabled
        ? 'notifications.report_expired_trial'
        : 'notifications.report_trial_limit'
      if (this.notificationMessage.keypath === reportLimitKeypath) {
        trackEvent(EventType.reports_toast_landing_click)
      }
      if (this.notificationMessage.keypath === 'notifications.report_sending') {
        trackEvent(EventType.reports_toast_bot_click)
      }
      const url = this.notificationMessage.link.href
      window.open(url, '_blank');
      event.preventDefault();
    },
  },
});
